import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { useState, FormEvent } from "react";
import { usePlanAddPaymentMethod } from "@/hooks/plans/use-plan-add-payment-method";
import { useUserConfig } from "@/hooks/user/use-user-config";
import { usePlanCreatePaymentIntent } from "@/hooks/plans/use-plan-payment-intent";

export function StripePaymentMethod({ subscriptionId }: PaymentMethodFormProps) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const addPaymentMethod = usePlanAddPaymentMethod();
  const { data, refetch } = useUserConfig();
  const [key, setKey] = useState(0);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);
    setError(null);

    // Create a new payment method
    const { error, setupIntent } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: window.location.href,
      },
      redirect: 'if_required'
    });

    if (error) {
      setError(error.message);
      setLoading(false);
      return;
    }

    await addPaymentMethod.mutateAsync({
      paymentMethodId: setupIntent.payment_method,
      subscriptionId,
    }).then(() => {
      setLoading(false);
      setKey((prevKey) => prevKey + 1);
    });

    refetch();
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <PaymentElement key={key} />
      <button 
        type="submit"
        disabled={!stripe || loading}
        className="inline-flex items-center rounded-md border border-transparent px-2 py-2 text-sm font-medium focus:outline-none focus:ring-2 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 focus:ring-indigo-500 focus:ring-offset-2 dark:bg-indigo-900 dark:text-indigo-100 dark:hover:bg-indigo-700 ml-auto"
      >
        {loading ? "Saving..." : "Add Payment Method"}
      </button>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </form>
  );
}
